import { ResultCode } from '@afterpaytouch/topaz-api'

export const topazErrors: Partial<Record<ResultCode, string>> = {
  [ResultCode.DUPLICATE_CARD]: 'duplicateCard',
  [ResultCode.UNACCEPTABLE_CARD]: 'unacceptableCard',
  [ResultCode.USER_CHALLENGE_FAILED]: 'userChallengeFailed',
}
